import PropTypes from 'prop-types';
import React from 'react';
import { Consumer as PageConsumer } from '../../../contexts/PageContext';

import './StickyTopBar.scss';

class BaseStickyTopBar extends React.PureComponent {
    componentDidMount() {
        this.props.context.setGlobalNavSticky(false);
    }

    render() {
        return (
            <div
                className={`component-Layout-StickyTopBar ${this.props.className}`}
                style={this.props.style}
            >
                {this.props.children}
            </div>
        );
    }
}

export default class StickyTopBar extends React.PureComponent {
    constructor(props) {
        super();
    }

    static propTypes = {
        /**
         * Content inside top bar
         */
        children: PropTypes.node,
        /**
         * z index (optional)
         */
        zIndex: PropTypes.number,
        /**
         * any injected class (optional)
         */
        className: PropTypes.string,
    };

    static defaultProps = {
        zIndex: 2,
    };

    render() {
        const style = { zIndex: `${this.props.zIndex}` };
        return (
            <PageConsumer>
                {(context) => (
                    <BaseStickyTopBar
                        className={this.props.className}
                        style={style}
                        context={context}
                    >
                        {this.props.children}
                    </BaseStickyTopBar>
                )}
            </PageConsumer>
        );
    }
}
